// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ot-5";
export var filledCircle = "_ot-4";
export var historyEntry = "_ot-3";
export var messageSideLeft = "_ot-1";
export var messageSideRight = "_ot-2";
export var orderTrackingCarouselWrapper = "_ot-6";
export var orderTrackingInfoContainer = "_ot-0";